export const ConsentConstants = {
  names: {
    GLOBAL_CONSENT: 'globalConsent',
    COSMOS_CONSENT: 'cosmosConsent',
    SOCIAL_NETWORKS_OFFERINGS_CONSENT: 'socialNetworksOfferingsConsent',
    SOCIAL_NETWORKS_MATCHING_CONSENT: 'socialNetworksMatchingConsent',
  },
  statuses: {
    ACCEPTED: 1,
    DECLINED: -1,
    NO_ANSWER: 0,
  }
};

export const P2PDJ_CONSENTS = {
  GENERAL_TERMS_CONSENT: 'generalTermsConsent',
  YETTEL_YSD_CONSENT: 'yettelAndYsdConsent',
  YETTEL_CONSENT: 'yettelConsent',
  YSD_CONSENT: 'ysdConsent',
  YETTEL_BANK_CONSENT: 'yettelBankConsent',
  SOCIAL_CONSENT: 'socialConsent',
  ACCEPT_ALL: 'acceptAll'
};
